module.exports = __webpack_public_path__ + "img/43800.6e41c8a0.jpg";